module.exports = __webpack_public_path__ + "img/msedge.6b2ae055.svg";